import React from 'react'
import { AccountType } from '@cbgms/api/modules/enums'
import { IAccount, IAccountName } from '@cbgms/api/modules/accounts'
import { BuildFullName } from '@cbgms/components/src/utils/FullName'
import { PartialKeys } from '@cbgms/base/utils/helpers/helpers'

export interface AccountNameProperties extends Pick<IAccount, 'Type' | 'Initials'>, PartialKeys<IAccountName, 'Title' | 'NamePrefix'> {}

interface Props {
  account: AccountNameProperties
}

const AccountName: React.FC<Props> = ({ account }: Props) => {
  return <>{BuildAccountName(account)}</>
}

AccountName.displayName = 'AccountName'
export default AccountName

export function BuildAccountName(account: AccountNameProperties): string | null {
  if (!account) return null
  if (account.Type === AccountType.Private)
    return BuildFullName({
      title: account.Title,
      initials: account.Initials,
      firstName: account.FirstName,
      lastName: account.Name,
      prefix: account.NamePrefix
    })
  else return getCompanyName(account)
}

const getCompanyName = (a: AccountNameProperties) => a.CompanyName

export const getContactNames = (account: AccountNameProperties): { primaryText?: string; secondaryText?: string } => {
  if (!account) return {}
  if (account.Type === AccountType.Private) {
    return {
      primaryText: BuildFullName({
        title: account.Title,
        initials: account.Initials,
        firstName: account.FirstName,
        lastName: account.Name,
        prefix: account.NamePrefix
      })
    }
  } else {
    return {
      primaryText: getCompanyName(account),
      secondaryText: BuildFullName({
        title: account.Title,
        initials: account.Initials,
        firstName: account.FirstName,
        lastName: account.Name,
        prefix: account.NamePrefix
      })
    }
  }
}
